import React, { useEffect } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { FormattedMessage, useIntl } from "react-intl";
import { MaterialIcons } from "@expo/vector-icons";
import * as Print from "expo-print";
import { serverDefaultUrl } from "../services/api";

const ModalPaperWallet = ({
  handleCloseModal,
  handleCloseWithTransaction,
  paperWalletResponse,
}) => {
  useEffect(() => {
    if (paperWalletResponse.paper_wallet && paperWalletResponse.code) {
      setTimeout(() => {
        shareTransactionSlip();
      }, 500);
    }
  }, [paperWalletResponse]);

  const intl = useIntl();

  const shareTransactionSlip = async () => {
    let html = `
        <html>
          <head>
          
          </head>
          <body>
            <style type="text/css">
              html, body {
                margin: 0;
                padding: 0;
              }
              .title{
                  margin-top: 10px;
                  font-size: 16px;
                  font-weight: normal;
                  color: #999999;
              }
              .info{
                  margin-top: 3px;
                  font-size: 16px;
                  font-weight: bold;
                  color: #999999;
              }
              @media print {
                html, body {
                  margin: 0;
                  padding: 0;
                }
              }
            </style>
            <div style="padding: 5px; width: 100%; font-size: 18px;">
            
                <div style="text-align: center; margin-bottom: 10px">
                  <img src="data:image/png;base64,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" style="max-width: 50%; width; auto; height: auto;">
                </div>

                <h2 align="center" style="text-align: center;">Chaves da Paper Wallet</h2>
    
                <div style="margin-top: 10px; margin-bottom: 10px; color: #999; font-size: 20px;">${paperWalletResponse.paper_wallet?.created_at}</div>
                
                <div class="title">Código</div>
                <div class="info">${paperWalletResponse.paper_wallet?.code}</div>
    
                <div class="title">Senha</div>
                <div class="info">${paperWalletResponse.validation_code}</div>

                <div class="title">Link de acesso:</div>
                <div class="info"><a href="${serverDefaultUrl}paper-wallet/view/${paperWalletResponse.paper_wallet?.code}/${intl.locale}">${serverDefaultUrl}paper-wallet/view/${paperWalletResponse.paper_wallet?.code}/${intl.locale}</a></div>
    
                <div class="title">Alteração de senha</div>
                <div class="info"><a href="${serverDefaultUrl}paper-wallet/update-password/${paperWalletResponse.paper_wallet?.code}">${serverDefaultUrl}paper-wallet/update-password/${paperWalletResponse.paper_wallet?.code}</a></div>
    
                <div style="padding: 10px; width: calc(100% - 20px); border-radius: 15px; background: linear-gradient(0deg, #196059, #1d8da5); margin-top: 5px;">
                <div style="color: #FFF">
                    GPX Tecnologia e Investimento<br />
                    CNPJ 44.181.382/0001-72
                </div>
                <div style="color: #FFF; margin-top: 10px;">
                    ID Blockchain<br />
                    ${paperWalletResponse.paper_wallet.uuid}
                </div>
            </div>
          </body>
        </html>
        `;
    // On iOS/android prints the given html. On web prints the HTML from the current page.
    await Print.printToFileAsync({
      //HtmlCertificate
      html: html,
    });
    //await shareAsync(uri, { UTI: ".pdf", mimeType: "application/pdf" });
  };

  return (
    <>
      <View style={styles.container}>
        <Text style={styles.title}>
          <FormattedMessage id="modalPaperWallet.txtCriacaoPwRealizadaCom" />
        </Text>{" "}
        <Text style={styles.success}>
          <FormattedMessage id="modalPaperWallet.txtCriacaoPwRealizadaComSucesso" />
        </Text>
        {"\n"}
        <View style={{ marginVertical: 12 }}>
          <Text style={styles.text}>
            <FormattedMessage id="modalPaperWallet.txtAtencaoCompartilharPw" />
          </Text>
        </View>
        {"\n\n"}
        <View style={{ marginBottom: 12, alignSelf: "flex-start" }}>
          <Text style={styles.text}>
            <FormattedMessage id="modalPaperWallet.txtGuardarSeguintesCredenciais" />
          </Text>
        </View>
        {"\n"}
        <View style={{ alignSelf: "flex-start" }}>
          <Text style={styles.text}>
            <FormattedMessage id="modalPaperWallet.txtCodigoDaPw" />
          </Text>
          {"\n"}
          <Text style={styles.generatedCodes}>{paperWalletResponse.code}</Text>
          {"\n\n"}
        </View>
        <View style={styles.hrLine}></View>
        <View style={{ alignSelf: "flex-start" }}>
          <Text style={styles.text}>
            <FormattedMessage id="modalPaperWallet.txtSenhaPw" />
          </Text>
          {"\n"}
          <Text style={styles.generatedCodes}>
            {paperWalletResponse.validation_code}
          </Text>
        </View>
        <View style={styles.hrLine}></View>
        {/* {"\n\n"}O código desta transação é{" "}
            <Text style={styles.success}>txId{uuidv4.generate()}</Text> */}
        <TouchableOpacity
          onPress={() => {
            handleCloseWithTransaction();
          }}
          style={{
            flexDirection: "row",
            alignSelf: "center",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 12,
          }}
        >
          <Image
            source={require("../../assets/pdf-download.svg")}
            style={{
              tintColor: "#077A97",
              width: 22,
              height: 22,
              marginRight: 6,
            }}
          />
          <Text
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: 12,
            }}
          >
            <FormattedMessage id="modalPaperWallet.btnAbrirPw" />
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={handleCloseModal}
          name="close"
          style={styles.btnFechar}
        >
          <FormattedMessage id="modalPaperWallet.btnFechar" />
        </TouchableOpacity>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 350,
    alignSelf: "center",
    alignItems: "center",
    padding: 12,
    marginTop: 60,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  headerRight: {
    marginTop: 25,
    padding: 15,
    alignItems: "flex-end",
  },
  image1: { width: "35%", height: "47%", resizeMode: "stretch" },
  image2: { width: 90, height: 90 },

  text: {
    fontSize: 14,
    textAlign: "justify",
  },

  btnFechar: {
    textTransform: "uppercase",
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
  },

  title: {
    fontSize: 16,
    marginTop: 30,
    textAlign: "center",
    textTransform: "uppercase",
    color: "#077A97",
    fontWeight: "bold",
  },

  generatedCodes: {
    marginTop: 10,
    fontSize: 18,
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#077A97",
  },

  success: {
    marginBottom: 30,
    fontSize: 16,
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#077A97",
  },
  cardCoin: {
    width: 250,
    position: "absolute",
    right: -80,
    bottom: -200,
  },

  hrLine: {
    height: 0.2,
    width: "100%",
    borderWidth: 0.2,
    marginTop: 10,
    marginBottom: 10,
    borderColor: "#077A97",
  },
});

export default ModalPaperWallet;
